<template>
  <div>
    <!-- User Interface controls -->
        <b-row>
            <b-col md="7" class="my-1">
                <b-form-group class="mb-0">
                    <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search" />
                        <b-input-group-append>
                            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="5" class="my-1">
                <b-form-group label-cols-md="4" label="Per page" class="mb-0">
                    <b-form-select :options="pageOptions" v-model="perPage" />
                </b-form-group>
            </b-col>
        </b-row>
    <!-- Main table element -->
    <b-table 
    small
    caption-top 
    show-empty 
    empty-text="Please wait for competencies to load." 
    striped 
    responsive
    stacked="md"
    :items="items" 
    :fields="fields" 
    :current-page="currentPage" 
    :per-page="perPage"
    :filter="filter"
    :sort-by.sync="sortBy" 
    :sort-desc.sync="sortDesc" 
    @filtered="onFiltered"
    >
      <template v-slot:cell(competency)="row">
            {{ row.item.title }}
        <div>
          <small>{{ row.item.category }} <span class="text-warning">Performed: {{ row.item.date }}</span></small>
        </div>
      </template>
      <template v-slot:cell(preceptor_name)="row">
        {{ row.item.preceptor_name }}
        <br>
        <!-- <b-link v-if="role == 'school'" @click="remind(row.item.id, row.item.reminders)">Remind</b-link> -->
      </template>
      <template v-slot:cell(created_at)="row">{{ moment(row.item.created_at).format('MMM DD YYYY') }}</template>
      <template v-slot:cell(actions)="row" class="text-nowrap">
        <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
        <b-button @click.stop="row.toggleDetails" class="btn btn-success mb-2">                  
          <span class="icon icon-info"></span>
        </b-button>
        <b-button-group class="mb-2">
        <b-button v-if="role == 'student'" @click.stop="editComp(row.item.id)" variant="warning"><span class="icon icon-pencil"></span></b-button>
        <b-button v-if="role =='student'" @click="deleteComp(row.item.id, row.item.preceptor_id, row.item.user_id)" variant="danger">
          <span class="icon icon-trash"></span>
        </b-button>
        <b-button v-if="row.item.comment" @click="showComment(row.item.comment)" variant="success">
          <span class="icon icon-eye"> Comment</span>
        </b-button>
        <b-button v-else variant="success" disabled>
          <span class="icon icon-block"> Comment</span>
        </b-button>
        </b-button-group>
      </template>
      <template v-slot:row-details="row">
        <b-card>
          <div class="font-weight-bold mb-3">{{ row.item.title }}</div>
          <table class="table table-striped bg-white table-sm">
            <tbody>
              <tr>
                <td>
                  <span class="font-weight-bold">Task</span>
                </td>
                <td>
                  {{ row.item.task }}
                </td>
              </tr>
              <tr>
                <td>
                  <span class="font-weight-bold">Performance Objectives</span>
                </td>
                <td>
                  {{ row.item.objectives }}
                </td>
              </tr>
              <tr>
                <td>
                  <span class="font-weight-bold">Directions to Candidate</span>
                </td>
                <td>
                  <div v-html="row.item.description"></div>
                </td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class="font-weight-bold mb-3">Steps</div>
          <table class="table table-striped bg-white table-sm">
            <tbody>
              <tr v-for="(step, index) in row.item.steps" :key="index">
                <td>
                  {{ index + 1 }}
                </td>
                <td v-html="step"></td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class="font-weight-bold mb-3">Considerations / Critical Inclusions</div>
          <table class="table table-striped bg-white table-sm">
            <tbody>
              <tr v-for="(consideration, index) in row.item.considerations" :key="index">
                <td>
                  {{ index + 1 }}
                </td>
                <td v-html="consideration"></td>
              </tr>
            </tbody>
          </table>
        </b-card>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
  const items = [];
  var moment = require("moment");
  export default {
    props: ["competencies", "user_role"],
    data() {
      return {
        items: this.competencies,
        role: this.user_role,
        moment: moment,
        fields: [{
            key: "competency",
            label: "Competency"
          },
          {
            key: "preceptor_name",
            label: "Preceptor"
          },
          {
            key: "created_at",
            label: "Sent"
          },
          {
            key: "actions",
            label: "Action"
          }
        ],
        filter: null,
        sortBy: "created_at",
        sortDesc: false,
        modalInfo: { title: '', content: '', id: '' },
        totalRows: this.competencies.length,
				pageOptions: [5, 15, 30, 60],
				currentPage: 1,
        perPage: 5,
      };
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            };
          });
      }
    },
    filters: {
      uppercase: function (v) {
        return v.toUpperCase();
      }
    },
    methods: {
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      showComment(comment) {
         Swal.fire({
                title: 'Student Comment',
                text: comment,
                confirmButtonText: 'Close'
            })
      },
      remind(id, number) {
        number = number + 1,
        axios
          .get("/instructor/student/pending/competency/reminder/" + id)
          .then(response => (this.items = response.data))
          .catch(function (error) {
            console.log(error);
          });
        Swal.fire({
              title: "We're sending the email",
              text: "The reminder number will update to " + number + " shortly." ,
              icon: 'success',
          })
      },
      info(preceptor_name, id, button) {
        this.modalInfo.title = `Are you sure you want to delete?`
        this.modalInfo.content = "This competency for " + preceptor_name + ". They will be notified."
        this.modalInfo.id = id
        this.$root.$emit('bv::show::modal', 'modalInfo', button)
      },
    resetModal() {
        this.modalInfo.title = ''
        this.modalInfo.content = ''
        this.modalInfo.id = ''
    },
    editComp(id) {
      window.location.href = "/student/edit/sent-competency/" + id;
    },
    deleteComp(id, preceptor, student) {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this! The Preceptor will be notified that it has been deleted.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                    if (result.isConfirmed) {
                      axios.delete('/student/delete/sent-competency/' + id)
                      .then(response => this.items = response.data)
                      .catch(function (error) {
                          // handle error
                          Swal.fire({
                          title: 'Oops',
                          text: "Something went wrong, please contact support.",
                          icon: 'warning'
                          })
                          console.log(error);
                      });
                      Swal.fire({
                          title: 'Deleted',
                          text: "If the preceptor does not know you deleted the Competency, please click Notify.",
                          icon: 'success',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#d33',
                          confirmButtonText: 'Notify',
                          cancelButtonText: 'Do Not Notify'
                      }).then((result) => {
                          if (result.isConfirmed) {
                              axios.post('/student/email/deleted/sent-competency', {
                                preceptor_id: preceptor,
                                student_id: student
                              })
                              .catch(function (error) {
                                // handle error
                                Swal.fire({
                                title: 'Oops',
                                text: "Something went wrong, please contact support.",
                                icon: 'warning'
                                })
                                console.log(error);
                            });
                          }
                      })                  
                }
            })
    },
    }
  };
</script>